import BuildWithUsForm from './ContactForm/BuildWithUsForm';

// V2 static-schema form (docs/CONTACT_FORM_V2.md); invest-in-us still uses the
// HubSpot-schema-driven HubspotContactForm.
export default function ContactForm() {
  return <BuildWithUsForm />;
}
